<template>
  <div>
    <div>
       <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading
        :active.sync="isLoading"
        loader="spinner"
        color="#36304a"
        :width="70"
      ></loading> -->
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar
          class="formCard"
          style="border-radius: 5px !important; padding-left: 0px"
          toggleable="lg"
          type="dark"
          variant="primary"
        >
          <b-navbar-nav>
            <b-button @click="previousFFView" size="sm" variant="light">
              <md-icon icon="gear-fill" aria-hidden="true"
                >skip_previous</md-icon
              >Back
            </b-button>
          </b-navbar-nav>
          <b-navbar-brand center>Sea Import Tracking</b-navbar-brand>
        </b-navbar>
        <banner-component
          :allModuleIdBanner="this.ALLMODULE ? this.ALLMODULE : ''"
          :jobSeriesBanner="this.JOBSERIES ? this.JOBSERIES : ''"
          :bannerClientName="this.CLIENTNAME ? this.CLIENTNAME : ''"
          iconId="fa fa-ship"
          :prbr_id="this.prbr_id?this.prbr_id:''"
        />
        <b-card class="formCard">
          <b-card-text>
            <!-- <b-card style="height:90px !important" class="HeaderMastBanner">
              <md-layout gutter>
                <md-layout md-flex="35">
                  <md-layout md-flex="100">
                    <b>Assignment No. : {{mainEntryData[0].ffImportSeries}}</b>
                  </md-layout>
                </md-layout>
              
                <md-layout md-flex="40">
                  <md-layout md-flex="100">
                    <b>Shipping Line : {{mainEntryData[0].shippingLine}}</b>
                  </md-layout>
                </md-layout>
              </md-layout>
              <md-layout gutter>
                <md-layout md-flex="35">
                  <md-layout md-flex="100">
                    <b>Importer Name : {{mainEntryData[0].Importer}}</b>
                  </md-layout>
                </md-layout>
               
                <md-layout md-flex="40">
                  <md-layout md-flex="100"></md-layout>
                </md-layout>
              </md-layout>
              <md-layout gutter>
                <md-layout md-flex="35">
                  <md-layout md-flex="100">
                    <b>
                      Exporter Name : {{mainEntryData[0].Exporter}}
                      <br>
                    </b>
                  </md-layout>
                </md-layout>
                <md-layout md-flex="25"></md-layout>
                <md-layout md-flex="40">
                  <md-layout md-flex="100"></md-layout>
                </md-layout>
              </md-layout>
            </b-card>
            <hr> -->
            <md-layout md-gutter class="labelMargtop">
              <md-layout md-flex="30"></md-layout>
              <md-layout md-flex="20">
                <b-form-checkbox
                  @change="addSameDateRadio"
                  id="checkbox-1"
                  v-model="allSame"
                  name="checkbox-1"
                  value="0"
                  unchecked-value="1"
                  >Dates are Same</b-form-checkbox
                >
              </md-layout>
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="20">
                <b-form-checkbox
                  @change="addSameDateReturn"
                  id="checkbox-2"
                  v-model="allSameReturn"
                  name="checkbox-2"
                  value="0"
                  unchecked-value="1"
                  >Dates are Same</b-form-checkbox
                >
              </md-layout>
            </md-layout>
            <md-layout
              gutter
              v-for="(item, index) in trackModal.allContainer"
              :key="index"
              class="labelMargtop"
            >
              <md-layout md-flex="25">
                <label>Container No.</label>

                <b-form-input
                  :formatter="capitalizeAll"
                  :value="item.ContainerNo"
                  disabled
                />
              </md-layout>

              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="20">
                <label v-if="stuffingType == 'warehouseStuffing'"
                  >De-stuffing Date</label
                >
                <label v-else>ICD out Date</label>

                <date-picker
                  :format="selectDateFormat"
                  lang="en"
                  id="HAWBDate"
                  name="HAWBDate"
                  v-model="icdOutDate[index]"
                ></date-picker>
              </md-layout>

              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="20">
                <label>Empty Return Date</label>

                <date-picker
                  :format="selectDateFormat"
                  lang="en"
                  id="HAWBDate"
                  name="HAWBDate"
                  v-model="emptyReturnDate[index]"
                ></date-picker>
              </md-layout>
              <md-layout md-flex="5"></md-layout>

              <md-layout md-flex="20">
                <label for="stuffingType">Remarks</label>
                <b-textarea
                  name="securityAmount"
                  id="securityAmount"
                  v-model="Remark[index]"
                ></b-textarea>
              </md-layout>
            </md-layout>

            <md-layout md-gutter class="gutr">
              <md-layout md-flex="40">
                <b-button
                  class="mt-3"
                  variant="primary"
                  id="addButtonLoaderpro"
                  @click="addTracking"
                  >Save & Submit</b-button
                >

                <md-spinner
                  md-indeterminate
                  id="loaderpro"
                  style="display: none"
                ></md-spinner>
              </md-layout>
            </md-layout>
          </b-card-text>
        </b-card>
      </b-card-text>
    </b-card>

    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="alertAddSeaImp"
    ></md-dialog-alert>
    <!-- @close="onCloseHandover" -->
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import axios from "axios";
import { ModelListSelect } from "vue-search-select";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import { globalPermissionStatus } from "../../helper/collection";
import VueTrix from "vue-trix";
import BannerComponent from "../allModuleForm/bannerComponent.vue";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

import { quillEditor } from "vue-quill-editor";

export default {
  beforeMount() {
    if (
      globalPermissionStatus("Sea Freight") &&
      this.$sessionsStorage.get("editffSeaImportId") != "" &&
      this.$sessionsStorage.get("editffSeaImportId") != undefined
    ) {
      this.$store.dispatch(
        "setCurrentRoute",
        "/seaImport/seaImportNormalTrack"
      );

      this.getData();
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
  },
  watch: {},
  data() {
    return {
      selectDateFormat,
      CLIENTNAME: "",
      JOBSERIES: "",
      ALLMODULE: "",
      prbr_id: "",
      allSame: "1",
      allSameReturn: "1",
      stuffingType: "",
      mainEntryData: [],
      editorOption: {
        modules: {},
      },
      editorContent: "",
      validate: true,
      isLoading: false,

      alert: {
        content:
          this.$sessionsStorage.get("editExportFCLId") != "" &&
          this.$sessionsStorage.get("editExportFCLId") != undefined
            ? "Data Updated Succesfully"
            : "Added Succesfully",
        ok: "ok",
      },

      checkList: [
        {
          value: "Yes",
        },
        {
          value: "No",
        },
      ],
      trackModal: {
        trackSeaImportId: "",
        ffImportId: this.$sessionsStorage.get("editffSeaImportId"),
        icdOutDate: "",
        Remark: "",
        emptyReturnDate: "",
        allContainer: [],
      },
      icdOutDate: [],
      emptyReturnDate: [],
      Remark: [],

      ExecutionModel: {
        executionImportId: "",
        ccImportId: this.$sessionsStorage.get("editCcImportId"),
        ccType: "Import",
        originalDate: "",
        firstCopyUpload: "",
        trSubmitDate: "",
        trSubmitNumber: "",
        securityAmount: "",
        uploadDo: "",
        receivedDo: "",
        checkOriginalInvoice: "",
        checkDoHard: "",
      },
      errorExecutionModel: {
        originalDate: "",
        firstCopyUpload: "",
        trSubmitDate: "",
        trSubmitNumber: "",
        securityAmount: "",
        uploadDo: "",
        receivedDo: "",
        checkOriginalInvoice: "",
        checkDoHard: "",
      },
      arrayErrorExecutionModel: {
        originalDate: "Select Date",
        firstCopyUpload: "Please Upload file",
        trSubmitDate: "Select TR Date",
        trSubmitNumber: "Enter TR Number",
        securityAmount: "Enter Container Security Amount",
        uploadDo: "Please Upload file",
        receivedDo: "Select Recieved Date",
        checkOriginalInvoice: "Select Yes/No",
        checkDoHard: "Select Yes/No",
      },
    };
  },

  mounted() {},
  beforeDestroy() {},
  destroyed() {},
  components: {
    DatePicker,
    ModelListSelect,
    // Loading,
    CustomLoader,
    VueTrix,
    quillEditor,
    BannerComponent,
  },
  computed: {
    clientList() {
      return this.getCLientData;
    },
    firstBlUploadView() {
      return this.ExecutionModel.firstCopyUpload != ""
        ? this.ExecutionModel.firstCopyUpload.split(",")
        : [];
    },
    secBlUploadView() {
      return this.ExecutionModel.uploadDo != ""
        ? this.ExecutionModel.uploadDo.split(",")
        : [];
    },
  },

  methods: {
    addSameDateRadio() {
      if (this.allSame == "1") {
        let ZeroInd = this.icdOutDate[0];
        this.trackModal.allContainer.map((x) => {
          this.icdOutDate.push(ZeroInd);
        });
      } else {
        this.icdOutDate = [];
      }
    },
    addSameDateReturn() {
      if (this.allSameReturn == "1") {
        let ZeroInd1 = this.emptyReturnDate[0];
        this.trackModal.allContainer.map((x) => {
          this.emptyReturnDate.push(ZeroInd1);
        });
      } else {
        this.emptyReturnDate = [];
      }
    },
    onFileChangeSecondBl() {
      var files = event.target.files || event.dataTransfer.files;

      var formData = new FormData();
      for (let i = 0; i < files.length; i++) {
        formData.append("file[]", files[i]);
      }
      const config = {
        headers: {
          "content-type": "multipart/form-data",
          Authorization: this.$sessionsStorage.get("editSeaNormalTrackId"),
        },
      };

      axios
        .post(
          `${URL_BASE}/Api_FFSeaImport/uploadSeaImportDoc.php`,
          formData,
          config
        )
        .then((result) => {
          this.ffHouseBL.secondBLupload = result.data;
          // console.log("fdsf", result.data);
        })
        .catch((err) => {
          throw err;
        });
    },

    validateCheckList(id) {
      let validate_new = true;

      Object.keys(this.errorExecutionModel).map((x) => {
        if (this.ExecutionModel[x] == "") {
          validate_new = false;
          this.errorExecutionModel[x] = this.arrayErrorExecutionModel[x];
        } else {
          this.errorExecutionModel[x] = "";
        }
      });

      if (validate_new == true) {
        this.validate = true;
      } else {
        this.validate = false;
      }
    },
    onCloseHandover(type) {
      if (type != "cancel") {
        this.$router.push({
          path: "/CCImport/CCImportDetails",
        });
      }
    },
    formatDate(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear(),
        minute = d.getMinutes(),
        Hour = d.getHours(),
        second = d.getSeconds();

      if (month.length < 2) month = "0" + month;

      if (day.length < 2) day = "0" + day;

      let dateNew = [year, month, day].join("-");

      //   let minuteNew = [Hour, minute].join(":");

      return dateNew;
    },

    addTracking() {
      this.icdOutDate.map((x) => {
        this.trackModal["icdOutDate"] += this.formatDate(x) + ",";
      });
      this.emptyReturnDate.map((x) => {
        this.trackModal["emptyReturnDate"] += this.formatDate(x) + ",";
      });
      this.Remark.map((x) => {
        this.trackModal["Remark"] += x + ",";
      });
      this.trackModal.allContainer.forEach((value, index) => {
        this.icdOutDate.forEach((val, index1) => {
          if (index1 == index) {
            value.ICDoutdate = val;
          }
        });
        this.emptyReturnDate.forEach((val2, index2) => {
          if (index2 == index) {
            value.returnDate = val2;
          }
        });
        this.Remark.forEach((val3, index3) => {
          if (index3 == index) {
            value.remarks = val3;
          }
        });

        value.uniqueContainerId = value.uniqueContainerId;
        value.ContainerNo = value.ContainerNo;
        value.containerTypeId = value.containerTypeId;
        value.containerType = value.containerType;
        // value.ICDoutdate = value.ICDoutdate;
        // value.returnDate = value.returnDate;
        // value.remarks = value.remarks;
      });
      let payload = {
        trackModal: this.trackModal,
        otherNewContainerFLow: this.mainEntryData.otherNewContainerFLow,
      };
      console.log(this.trackModal);
      console.log(payload);
      if (this.validate == true) {
        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_FFSeaImport/addImportTrackingFF.php`,
          data: JSON.stringify(payload),
          // data: JSON.stringify(this.trackModal),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };
        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (status == 200 && data) {
              $("#addButtonLoaderpro").css("display", "block");
              $("#loaderpro").css("display", "none");
              if (this.trackModal.trackSeaImportId != "") {
                this.alert.content = "Data Updated Succesfully";
              } else {
                this.alert.content = "Data Inserted Succesfully";
              }
              this.$refs["alertAddSeaImp"].open();
            }
          })
          .catch((error) => {});
      }
    },

    getData() {
      this.isLoading = true;

      let vehicle_drive = {
        itemCode: "itemCode",
        ffImportId: this.$sessionsStorage.get("editffSeaImportId"),
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_FFSeaImport/fetchNormalSeaImpTrack_NewV3.php`,
        data: JSON.stringify(vehicle_drive),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            console.log(data, "jitu");
            let otherNewContainerFLow = 0;
            let allNewContainers = [];
            this.prbr_id = data.containerList[0].prbr_id;
            this.CLIENTNAME = data.containerList[0].Importer;
            this.ALLMODULE = data.containerList[0].ffImportId;
            this.JOBSERIES = data.containerList[0].ffImportSeries;
            if (data.allNewContainers.length > 0) {
              allNewContainers = data.allNewContainers;
            }
            let array = [];
            if (data.containerList.length > 0) {
              this.mainEntryData = data.containerList;
              this.stuffingType = data.containerList[0].stuffingType;
              otherNewContainerFLow =
                data.containerList[0].otherNewContainerFLow;
              this.mainEntryData.otherNewContainerFLow =
                data.containerList[0].otherNewContainerFLow;
              if (data.containerList[0].newContainerFlow == "1") {
                if (data.allNewContainers.length > 0) {
                  this.trackModal.allContainer = data.allNewContainers;
                }
              } else {
                array = data.containerList[0].ContainerNo.split(",");
                array.map((x) => {
                  let obj = {
                    ContainerNo: x,
                  };
                  this.trackModal.allContainer.push(obj);
                });
              }
            }
            if (otherNewContainerFLow == 0) {
              if (data.ffImpTrackdata.length > 0) {
                Object.keys(data.ffImpTrackdata[0]).map((p) => {
                  if (p == "icdOutDate") {
                    this.icdOutDate = data.ffImpTrackdata[0][p].split(",");
                  } else if (p == "emptyReturnDate") {
                    this.emptyReturnDate = data.ffImpTrackdata[0][p].split(",");
                  } else if (p == "Remark") {
                    this.Remark = data.ffImpTrackdata[0][p].split(",");
                  } else {
                    this.trackModal[p] = data.ffImpTrackdata[0][p] || "";
                  }
                });
              }
            } else if (otherNewContainerFLow == 1) {
              if (allNewContainers.length > 0) {
                allNewContainers.forEach((val, key) => {
                  if (
                    val.ICDoutdate != undefined &&
                    val.ICDoutdate != null &&
                    val.ICDoutdate != ""
                  ) {
                    this.icdOutDate.push(val.ICDoutdate);
                  }
                  console.log("this.icdOutDate=>", this.icdOutDate);
                  if (
                    val.returnDate != undefined &&
                    val.returnDate != null &&
                    val.returnDate != ""
                  ) {
                    this.emptyReturnDate.push(val.returnDate);
                  }
                  if (
                    val.remarks != undefined &&
                    val.remarks != null &&
                    val.remarks != ""
                  ) {
                    this.Remark.push(val.remarks);
                  }
                });
              }
            }
            console.log(data);
            // this.allContainer = data.containerList;

            this.isLoading = false;
          }
        })
        .catch((error) => {});
    },
    addNew() {
      this.$router.push({
        path: "/client/addClient",
      });
    },

    previousFFView() {
      window.history.go(-1);
    },
    onFileChangeBoe(id) {
      var files = event.target.files || event.dataTransfer.files;

      var formData = new FormData();
      for (let i = 0; i < files.length; i++) {
        formData.append("file[]", files[i]);
      }
      const config = {
        headers: {
          "content-type": "multipart/form-data",
          Authorization: this.$sessionsStorage.get("editSeaNormalTrackId"),
        },
      };

      axios
        .post(
          `${URL_BASE}/Api_FFSeaImport/uploadSeaImportDoc.php`,
          formData,
          config
        )
        .then((result) => {
          if (id == "Do") {
            this.ExecutionModel.uploadDo = result.data;
          } else {
            this.ExecutionModel.firstCopyUpload = result.data;
          }
        })
        .catch((err) => {
          throw err;
        });
    },
  },
};
</script>
<style>
.md-direction-bottom-right {
  width: 18% !important;
}

.center {
  text-align: center;
}

.b-form-input-container {
  margin: 4px 0 12px !important;
}

.activeClass {
  display: none;
}
.error {
  color: red;
}
</style>



// WEBPACK FOOTER //
// seaImportNormalTrack.vue?4a954f40